import React, { Component } from 'react';

/**
 * Checks if the error was caused by Google Translate modifying DOM nodes.
 */
const isGoogleTranslateError = (error) => {
    if (!error) return false;
    const msg = String(error.message || error);
    return (
        msg.includes("removeChild") ||
        msg.includes("insertBefore") ||
        msg.includes("not a child of this node") ||
        msg.includes("NotFoundError")
    );
};

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // If the error is caused by Google Translate DOM mutations, do not break the UI
        if (isGoogleTranslateError(error)) {
            return { hasError: false, error: null };
        }
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        if (isGoogleTranslateError(error)) {
            console.warn('Ignored harmless Google Translate DOM discrepancy:', error);
            return;
        }
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="container py-5 text-center my-5">
                    <div className="card shadow-sm p-4 mx-auto" style={{ maxWidth: '600px' }}>
                        <div className="card-body">
                            <i className="fa fa-exclamation-circle text-danger fa-3x mb-3"></i>
                            <h3 className="card-title text-danger">Something went wrong</h3>
                            <p className="card-text text-muted">
                                An unexpected error occurred while rendering this page.
                            </p>
                            <button
                                className="btn btn-primary mt-2"
                                onClick={this.handleReload}
                            >
                                <i className="fa fa-refresh mr-2"></i> Reload Page
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
